<template>
    <div class="home">
        <banner :bannerData="bannerData"></banner>
        <div v-if="isPc" class="pl">
            请选择
        </div>
        <div class="tickets" v-for="(item, index) in tickets" :key="index">
            <div class="tickets-title">
                <div class="title"><img src="./static/tickets.png" alt=""> {{item.ticketName}}</div>
                <div v-if="item.chargeType==1" class="fee">￥{{item.price}}</div>
                <div v-else class="fee">免费</div>
            </div>
            <div class="tickets-content">
                <div class="tips">
                    <div v-if="item.discounMoney">
                        <span class="hui">惠</span>
                        {{item.discounDate}}前付款，可享受{{item.discounMoney}}元优惠
                    </div>
                    <div>
                        <span class="tip">!</span>
                        <!-- 总数：{{item.sellCount}} 每人限购数：{{item.maxAmount}}-->
                        {{item.ticketDesc}} 
                    </div>
                </div>
                <div class="isover" v-if="item.isover">
                    <img class="over" src="./static/over.png" alt="">
                </div>
                <div class="check" @click="choose(index,item)" v-if="!isPc&&!item.isover">
                    <img v-if="active===index" src="./static/checked.png" alt="">
                    <img v-else src="./static/unchecked.png" alt="">
                </div>
                <!-- isPc&&!item.isover -->
                <div v-if="isPc&&!item.isover" class="signUp"  @click="goPay('pc',item)">
                     去报名
                </div>
            </div>
        </div>
        <div class="m-goPay" @click="goPay('m')">
            选好了，去报名
        </div>
    </div>
</template>
<script>
import Banner from '../../components/banner/index.vue'
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
    data() {
        return {
            ticket:null,
            tickets: [
                {title: '医院单位', fee: 1200, benefit: '6月30日前付款，可享受200元优惠', tips: '分会委员及会员单位、助力培优计划参与单位、其他社会办医院及其他医疗机构代表均从此通道报名，正确填写单位名称，即可获得相应的票价'},
                {title: '企业单位', fee: 2000, benefit: '', tips:'医疗相关企业及各类机构代表请选择此票种'},
                {title: '地方协会组织', fee: 0, benefit: '', tips:''},
                {title: '国家机关单位', fee: 900, benefit: '', tips:'',isover: true},
            ],
            active: -1,
            bannerData: {}
        }
    },
    components: {
        Banner
    },
    methods: {
        goPay(type,item){
            console.log('去报名',this.ticket)
              if(type=='pc'){
                this.ticket=item
              }
              if(!this.ticket){
                  this.$alert('请选择门票', '',{
                    showClose: false
                  })
                  return;
              }
             localStorage.setItem('ticket',JSON.stringify(this.ticket))
          
             this.$router.push('/register')
        },
        choose(index,item) {
            this.active = index
            this.ticket=item

            console.log('选择了')
        },
        async getMeetingInfo() {
            const res = await http.get(`${apis.getMeetingInfo}/${this.meetingId}`)
            console.log('titles',res)
            res.result.meetingTicketList.forEach((item)=>{
                let endtime=new Date(item.sellEndTime.replace(/\-/g,'/')).getTime()
                let nowtime=new Date().getTime()
                // console.log('endtime',)
                if(endtime-nowtime>=0){
                   item.isover=false
                }else{
                  item.isover=true
                }
            })
            this.tickets = res.result.meetingTicketList
            // this.ticket = this.tickets[0]
            this.bannerData = res.result.meeting
        }
    },
    computed:{
        isPc() {
            return this.$store.state.isPc
        },
        meetingId() {
            return this.$store.state.meetingId || localStorage.getItem('meetingId')
        }
    },
    created() {
        this.getMeetingInfo()
    }
}
</script>
<style lang="stylus" scoped>
    .m-goPay {
      position fixed
      left 0
      bottom 0
      width 100%
      height 80px
      line-height 80px
      text-align center
      background-color   #2852a6
      font-size 30px
      color #fff
    }
    .home
        width 100%
        min-height 100vh
        background #f1f1f1
        box-sizing border-box
        padding-bottom 120px
    .tickets
        background #ffffff
        padding 15px 23px 0px
        margin-top 16px
        text-align justify
        .tickets-title
            height 65px
            line-height 65px
            display flex
            justify-content space-between
            align-items center
            border-bottom 1px dashed rgba(199,199,199,1)
            .title
                color #333333
                display flex
                align-items center
                font-size 32px
                img
                    width 32px
                    margin-right 13px
            .fee
                color #FF4E00
                font-size 30px
        .tickets-content
            padding 26px 20px 21px 20px
            display flex
            justify-content space-between
            .tips
                width 650px
                // margin-right 10px
                div
                    margin-bottom 24px
                    padding-left 50px
                    position relative
                    min-height 40px
                .hui
                    display inline-block
                    width 33px
                    height 33px
                    line-height 33px
                    text-align center
                    background rgba(99,99,99,1)
                    border 1px solid rgba(99,99,99,1)
                    border-radius 7px
                    font-size 25px
                    color #fff
                    position absolute
                    left 0
                    top 5px
                .tip
                    display inline-block
                    width 28px
                    height 28px
                    line-height 28px
                    text-align center
                    background rgba(99,99,99,1)
                    border 2px solid rgba(99,99,99,1)
                    border-radius 50%
                    font-size 25px
                    color #ffffff
                    padding-top 3px
                    box-sizing border-box
                    position absolute
                    left 0
                    top 8px
            .check
                align-self center
                img 
                    width 28px
                    height 28px
            .isover
                    width 86px
                    height 67px
                    background url('./static/yuan.png')
                    background-size 100% 100%
                    display flex
                    justify-content  center
                    align-items center
                    .over 
                        width 46px
    @media screen and (min-width: 800px)
        .m-goPay{
          display none
        }
        .home
            width 940px
            margin 0 auto
            min-height 100vh
            padding-bottom 150px
            background #fff
            box-sizing border-box
        .pl
            padding 37px 30px 0px
            color #333333
            font-size 24px
        .tickets
            background #ffffff
            padding 15px 16px 0px
            margin 30px
            text-align justify
            border 1px solid #C8C8C8
            .tickets-title
                height 65px
                line-height 65px
                display flex
                justify-content space-between
                align-items center
                border-bottom 1px dashed rgba(199,199,199,1)
                .title
                    color #333333
                    display flex
                    align-items center
                    font-size 24px
                    img
                        width 32px
                        margin-right 13px
                .fee
                    color #FF4E00
                    font-size 24px
            .tickets-content
                padding 26px 20px 21px 20px
                display flex
                justify-content space-between
                align-items center
                .tips
                    max-width 650px
                    margin-right 60px
                    div
                        margin-bottom 20px
                        padding-left 40px
                        position relative
                        min-height 20px
                        font-size 18px
                    .hui
                        display inline-block
                        width 26px
                        height 26px
                        line-height 26px
                        text-align center
                        background rgba(99,99,99,1)
                        border 1px solid rgba(99,99,99,1)
                        border-radius 4px
                        font-size 18px
                        color #fff
                        position absolute
                        left 0
                        top 0px
                    .tip
                        display inline-block
                        width 22px
                        height 22px
                        line-height 22px
                        text-align center
                        background rgba(99,99,99,1)
                        border 2px solid rgba(99,99,99,1)
                        border-radius 50%
                        font-size 18px
                        color #ffffff
                        padding-top 0px
                        box-sizing border-box
                        position absolute
                        left 2px
                        top 3px
                .isover
                    width 86px
                    height 67px
                    background url('./static/yuan.png')
                    background-size 100% 100%
                    display flex
                    justify-content  center
                    align-items center
                    .over 
                        width 46px
                .check
                    align-self center
                    img 
                        width 28px
                        height 28px
                .signUp
                    width 110px
                    height 32px
                    background #2852A6
                    border-radius 6px
                    font-size 20px
                    line-height 32px
                    text-align center
                    color #fff
                    cursor pointer

</style>